$(document).ready(function () {
  var SPMaskBehavior = function (val) {
      return val.replace(/\D/g, "").length === 11
        ? "(00) 00000-0000"
        : "(00) 0000-00009";
    },
    spOptions = {
      onKeyPress: function (val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
      },
    };

  $("#cpf.politica").mask("000.000.000-00");
  $("#celular").mask(SPMaskBehavior, spOptions);

  $("#loginForm").on("submit", function (e) {
    $("#btnSubmit").attr("disabled", true);
  });
});

angular.module("app").requires.push("ngMask");
angular
  .module("app")
  .controller("CadastroFormController", function ($scope, $http, $timeout) {
    $scope.cadastro = {};

    $scope.initCadastro = function () {
      return ($scope.cadastro = {
        tipo: "F",
        aceita_receber_emails_marketing: true,
        concordo_termos_uso: true,
        possui_conta_bancaria: false,
      });
    };

    $scope.save = function (e) {
      e.preventDefault();

      $scope.salvando = true;

      $http({
        url: window.location.href,
        method: "post",
        data: $scope.cadastro,
      })
        .then(function (res) {
          if (res.data.status) {
            const callback = () => {
              window.location.href = res.data.redirect;
            };

            if (window.gtag) {
              gtag("event", "conversion", {
                send_to: "AW-635137019/CGFxCMa8uuoBEPvX7a4C",
                event_callback: callback,
              });
            } else {
              callback();
            }
          } else {
            $scope.salvando = false;
          }
        })
        .catch(function (res) {
          $scope.salvando = false;
        });
    };

    $scope.changeCep = function (index) {
      if (!$scope.cadastro.cep || $scope.cadastro.cep.length !== 9)
        return false;
      $http({
        method: "GET",
        url: "/buscacep/" + $scope.cadastro.cep,
      }).then(function (response) {
        if (!response.data) return false;
        $scope.cadastro.logradouro = response.data.logradouro;
        $scope.cadastro.bairro = response.data.bairro;
        $scope.cadastro.municipio_id = response.data.ibge
          ? Number(response.data.ibge)
          : null;
        $scope.cadastro.uf = response.data.uf;
      });

      return false;
    };
  });
